var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { padding: "30px 40px 50px 40px" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Información General" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label:
                                    _vm.formFields.activo.value == 1
                                      ? "Activo"
                                      : "Inactivo",
                                  color: "#FDEF68",
                                  "persistent-hint": "",
                                  hint: _vm.warningInactivo,
                                  readonly: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.activo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.activo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.activo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { x12: "", sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|max:80|NombreUnico",
                                    expression: "'required|max:80|NombreUnico'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.nombre.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.nombre.id
                                  ),
                                  "data-vv-name": _vm.formFields.nombre.id,
                                  counter: "80",
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.nombre.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.nombre,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.nombre.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      "required|max:10|rut|rutFormato|RutUnico",
                                    expression:
                                      "'required|max:10|rut|rutFormato|RutUnico'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.rut.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.rut.id
                                  ),
                                  "data-vv-name": _vm.formFields.rut.id,
                                  counter: "10",
                                  disabled: _vm.modoVer || _vm.nuncaEdit
                                },
                                model: {
                                  value: _vm.formFields.rut.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.rut, "value", $$v)
                                  },
                                  expression: "formFields.rut.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.giro.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.giro.id
                                  ),
                                  "data-vv-name": _vm.formFields.giro.id,
                                  items: _vm.lstGiros,
                                  "item-text": "nombre",
                                  "item-value": "id",
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.giro.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.giro, "value", $$v)
                                  },
                                  expression: "formFields.giro.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { x12: "", sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "max:250",
                                    expression: "'max:250'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.direccion.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.direccion.id
                                  ),
                                  "data-vv-name": _vm.formFields.direccion.id,
                                  counter: "250",
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.direccion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.direccion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.direccion.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Contacto Técnico" } },
                        [
                          _vm._t("prependContactoTecnico"),
                          _c(
                            "v-flex",
                            { attrs: { x12: "", sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "max:80",
                                    expression: "'max:80'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.tecnicoNombre.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.tecnicoNombre.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.tecnicoNombre.id,
                                  counter: "80",
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.tecnicoNombre.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tecnicoNombre,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.tecnicoNombre.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { x12: "", sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      max: 200,
                                      email: true,
                                      regex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/
                                    },
                                    expression:
                                      "{\n                  max: 200,\n                  email: true,\n                  regex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.([a-zA-Z]{2,4})+$/,\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.tecnicoEmail.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.tecnicoEmail.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.tecnicoEmail.id,
                                  counter: "200",
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.tecnicoEmail.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tecnicoEmail,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.tecnicoEmail.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { x12: "", sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "max:11|telefonoFormato",
                                    expression: "'max:11|telefonoFormato'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.tecnicoTelefono.label,
                                  placeholder: "56999999999",
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.tecnicoTelefono.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.tecnicoTelefono.id,
                                  counter: "11",
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.tecnicoTelefono.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tecnicoTelefono,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.tecnicoTelefono.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Contacto Comercial" } },
                        [
                          _vm._t("prependContactoTecnico"),
                          _c(
                            "v-flex",
                            { attrs: { x12: "", sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "max:80",
                                    expression: "'max:80'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.comercialNombre.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.comercialNombre.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.comercialNombre.id,
                                  counter: "80",
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.comercialNombre.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.comercialNombre,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.comercialNombre.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { x12: "", sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      max: 200,
                                      email: true,
                                      regex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/
                                    },
                                    expression:
                                      "{\n                  max: 200,\n                  email: true,\n                  regex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.([a-zA-Z]{2,4})+$/,\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.comercialEmail.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.comercialEmail.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.comercialEmail.id,
                                  counter: "200",
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.comercialEmail.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.comercialEmail,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.comercialEmail.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { x12: "", sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "max:11|telefonoFormato",
                                    expression: "'max:11|telefonoFormato'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.comercialTelefono.label,
                                  placeholder: "56999999999",
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.comercialTelefono.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.comercialTelefono.id,
                                  counter: "11",
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.comercialTelefono.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.comercialTelefono,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.comercialTelefono.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }